module.exports = __webpack_public_path__ + "img/portfolio.46d107e6.png";